import type { ReactNode } from 'react';

import { atoms } from '../../css/atoms/atoms.css';
import { Box } from '../Box/Box';
import { Text, type TextProps } from '../Text/Text';

interface ListItemTextProps {
  primary: ReactNode;
  primaryTextProps?: TextProps;
  secondary?: ReactNode;
  secondaryTextProps?: TextProps;
}

export const ListItemText: React.FC<React.PropsWithChildren<ListItemTextProps>> = ({
  primary,
  secondary,
  primaryTextProps,
  secondaryTextProps,
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="flexStart">
      <Text {...primaryTextProps}>{primary}</Text>
      {secondary && (
        <Text
          className={atoms({
            paddingTop: 'xsmall',
          })}
          {...secondaryTextProps}
        >
          {secondary && secondary}
        </Text>
      )}
    </Box>
  );
};
